import React from 'react';
import moment from 'moment';
import {
  object, number, string
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const defaults = {
  name: '',
  description: '',
  type: 'REWARD',
  active: false,
  startAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '00:00',
  },
  endAt: {
    date: '',
    time: '',
  },
  image: '',
};

const FormBadge = ({
  badge,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        name: string().required(),
      }),
      stored: badge ? {
        ...badge,
        startAt: {
          date: moment(badge.startAt).format('YYYY-MM-DD'),
          time: moment(badge.startAt).format('HH:mm'),
        },
        endAt: {
          date: moment(badge.endAt).format('YYYY-MM-DD'),
          time: moment(badge.endAt).format('HH:mm'),
        },
      } : undefined,
      api: '/api/site/badges',
      onSubmit: (v) => ({
        ...v,
        startAt: moment(
          `${v.startAt.date} ${v.startAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        endAt: moment(
          `${v.endAt.date} ${v.endAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
      }),
    }}
  >
    <div className="row">
      <div className="col col-8">
        <div className="row">
          <div className="col">
            <FormGroup name="name" label="Name"/>
          </div>
          <div className="col">
            <FormGroup name="type" label="Type" as="select">
              <option value="REWARD">Reward</option>
              <option value="REDEMPTION">Redemption</option>
            </FormGroup>
          </div>
        </div>

        <FormGroup name="description" />

        <div className="row">
          <div className="col-auto">
            <div className="form-group">
              <label>Active</label>
              <FormCheckGroup
                name="active"
                type="checkbox"
                label=""
                asSwitch
              />
            </div>
          </div>
          <div className="col">
            <div className="form-row">
              <div className="col">
                <FormGroup
                  name="startAt.date"
                  type="date"
                  label="Start Date"
                />
              </div>
              <div className="col">
                <FormGroup name="startAt.time" type="time" label="Time" />
              </div>
            </div>
            <div className="form-row">
              <div className="col">
                <FormGroup
                  name="endAt.date"
                  type="date"
                  label="End Date"
                />
              </div>
              <div className="col">
                <FormGroup name="endAt.time" type="time" label="Time" />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="col col-4">
        <FormGroup
            name="image"
            label="Image"
            as="coverImg"
            api="/api/site/badges/files"
        />
      </div>
    </div>
  </FormResource>
);

export default FormBadge;
